import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/queryClient";
import App from "./App";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary";
import { errorLogger } from "./services/errorLogger.service";
import { initPerformanceMonitoring } from "./utils/performance";

// Service worker registration is handled automatically by vite-plugin-pwa

// Initialize Sentry error tracking (optional - works without DSN)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  errorLogger.initializeSentry(sentryDsn);
}

// Initialize performance monitoring (production only)
if (import.meta.env.PROD) {
  initPerformanceMonitoring();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
